<template>
  <div>
    <!-- 学生障碍类型占比 -->
    <Echart :options="options" height="260px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    RBdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    RBdata: {
      handler(newData) {
        // let arr = newData.
        let colorList = [
          '#e9b7ba',
          '#70dada',
          '#cebfe8',
          '#ffcfa7',
          '#8ec9f3',
          '#afa3f5',
          '#00d488',
          '#3feed4',
          '#3bafff',
          '#f1bb4c'
        ];
        this.options = {
          grid: {
            top: 0,
            left: 0
            // right: "10%"
          },

          legend: {
            // padding:[0,0,30,0],
            bottom: '10px',
            left: '10%',
            right: '10%',
            itemGap: 10,
            itemWidth: 16,
            itemHeight: 16,
            textStyle: {
              color: '#fff',
              fontSize: 13
            },
            data: newData.data.name
          },
          series: [
            {
              radius: '39%',
              center: ['50%', '40%'],
              itemStyle: {
                normal: {
                  color: function (params) {
                    return colorList[params.dataIndex];
                  }
                }
              },
              hoverAnimation: false, // 鼠标经过不放大
              labelLine: {
                normal: {
                  length: 20,
                  length2: 30,
                  lineStyle: {
                    color: '#a8c76d',
                    width: 2
                  }
                  // align: "center"
                }
                // color: "#000",
                // emphasis: {
                //   show: true
                // }
              },
              label: {
                position: 'outside',
                normal: {
                  formatter: '{b}: {d}%',
                  textStyle: {
                    color: '#fff', // 改变标示文字的颜色
                    fontSize: 14
                  }
                }
              },
              type: 'pie',
              data: newData.data
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
